import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend, { HttpBackendOptions } from 'i18next-http-backend';
import { fetchTranslation, loadTranslationPath } from '@app/utils/translations';

const supportedLanguages: Record<string, string> = {
	en: 'en-GB',
	ar: 'ar-EG',
	el: 'el-GR',
};

i18next
	// i18next-http-backend
	// loads translations from 'public/locales'
	// https://github.com/i18next/i18next-http-backend
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		detection: {
			convertDetectedLanguage: (lng) => {
				if (!lng) return supportedLanguages.en;

				// Get the base language code (e.g., 'en' from 'en-US')
				const baseLanguage = lng.split('-')[0];

				// Return the matching supported language or default to en-GB
				return supportedLanguages[baseLanguage] || supportedLanguages.en;
			},
			order: ['localStorage', 'navigator'],
			caches: ['localStorage'],
		},
		debug: false,
		partialBundledLanguages: true,
		load: 'currentOnly',
		ns: ['common'],
		supportedLngs: Object.values(supportedLanguages),
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		defaultNS: 'common',
		backend: {
			loadPath: loadTranslationPath,

			request: async (_, url, __, callback) => {
				try {
					const response = await fetchTranslation(url);
					callback(null, {
						data: response,
						status: 200,
					});
				} catch (e) {
					console.error('Failed to fetch translations', e);
					callback(null, {
						data: {},
						status: 200,
					});
				}
			},
		} satisfies HttpBackendOptions,
		react: {
			// this is to trigger suspense fallback when language is changing
			bindI18n: 'languageChanged languageChanging',
		},
	});

export default i18next;
